import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { PageRoute } from 'shared/components';
import {
  IncomeContainer,
  LinkIncomeContainer,
  ManualUploadContainer,
  PointservCallbackContainer,
} from 'components';

const IncomeRoutes = () => {
  const history = useHistory();
  const [hasSeenIncomeOption, setHasSeenIncomeOption] = useState(false);

  useEffect(() => {
    if (history.location.pathname.includes('/link')) setHasSeenIncomeOption(true);
  }, [history.location.pathname, setHasSeenIncomeOption]);

  return (
    <>
      <PageRoute exact path="/applications/:uuid/income/review" hasLeaveSurvey>
        <IncomeContainer hasSeenIncomeOption={hasSeenIncomeOption} />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/income/link/:type" hasLeaveSurvey>
        <LinkIncomeContainer />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/income/pointserv-callback" hasLeaveSurvey>
        <PointservCallbackContainer />
      </PageRoute>
      <PageRoute exact path="/applications/:uuid/income/upload/:type" hasLeaveSurvey>
        <ManualUploadContainer />
      </PageRoute>
    </>
  );
};

export default IncomeRoutes;
